const initState = {
    /// README: SHARED
    isFilesAdded: false,

    /// README: NEW MARKER WRAPPER PAGE
    isMarkerCreating: false,
    isMarkerCreated: false,

    /// README: EDIT MARKER WRAPPER PAGE
    isMarkerUpdating: false,
    isMarkerUpdated: true,

    /// README: BRIEF MARKER WRAPPER PAGE (used to handle both brief modal and its child edit modal)
    isBriefForceClose: false,

    /// README: COMMENT
    isCommentAdding: false,
    isCommentAdded: false,

    isMarkerDeleting: false,
    isMarkerDeleted: true,
}

const sketchControlReducer = (state = initState, action) => {
    /// README: BRIEF MARKER
    if (action.type === 'OPEN_BRIEF_MARKER_MODAL') {
        console.log("brief marker sk reducer");
        return {
            ...state,
            isBriefForceClose: false,
        }
    }
    /// README: ADDING NEW MARKER
    else if (action.type === 'OPEN_NEW_MARKER_MODAL') {
        console.log("opening marker sk reducer");
        return {
            ...state,
            isMarkerCreating: false,
            isFilesAdded: false,
            isMarkerCreated: false,
        }
    }
    else if (action.type === "MARKER_ADDING") {
        return {
            ...state,
            isMarkerCreating: true,
        }
    }
    else if (action.type === "MARKER_FILES_ADDED") {
        return {
            ...state,
            isFilesAdded: true,
        }
    }
    else if (action.type === "MARKER_ADDED") {
        return {
            ...state,
            isMarkerCreating: false,
            isFilesAdded: false,
            isMarkerCreated: true,
        }
    }

    /// README: UPDATING MARKER
    else if (action.type === "OPEN_EDIT_MARKER_MODAL") {
        console.log("editing marker sk reducer");
        return {
            ...state,
            isMarkerUpdating: false,
            isFilesAdded: false,
            isMarkerUpdated: false,
        }
    }
    else if (action.type === "MARKER_UPDATING") {
        return {
            ...state,
            isMarkerUpdating: true,
        }
    }
    else if (action.type === "MARKER_FILES_ADDED") {
        return {
            ...state,
            isFilesAdded: true,
        }
    }
    else if (action.type === "MARKER_UPDATED") {
        return {
            ...state,
            isMarkerUpdating: false,
            isFilesAdded: false,
            isMarkerUpdated: true,
            isBriefForceClose: true,
        }
    }

    /// README: DELETING A MARKER
    else if (action.type === "DELETE_A_MARKER") {
        return {
            ...state,
        }
    }

    /// README: COMMENT ON MARKER HANDLING
    else if (action.type === "COMMENT_ADDING") {
        return {
            ...state,
            isCommentAdding: true,
            isCommentAdded: false,
        }
    }
    else if (action.type === "COMMENT_DP_ADDED") {
        return {
            ...state,
            isFilesAdded: true,
        }
    }
    else if (action.type === "COMMENT_ADDED") {
        return {
            ...state,
            isCommentAdding: false,
            isCommentAdded: true,
        }
    }
    else if (action.type === "DELETE_MARKER") {
        return {
            ...state,
            isMarkerDeleting: true,
        }
    }
    else if (action.type === "MARKER_DELETED") {
        return {
            ...state,
            isMarkerDeleted: false,
        }
    }
    else if (action.type === "OPEN_DELETE_MARKER_MODAL") {
        return {
            ...state,
            isMarkerDeleted: true,
        }
    }

    else if (action.type === "COMMENT_DELETING") {
        return {
            ...state,
            isCommentDeleting: true,
            isCommentDeleted: false,
        }
    }

    else if (action.type === "COMMENT_DELETED") {
        return {
            ...state,
            isCommentDeleting: false,
            isCommentDeleted: true,
        }
    }

    else if(action.type === "OPEN_DELETE_COMMENT_MODAL"){
        return{
            ...state,
            isCommentDeleted:false,
        }
    }

    return state;
}

export default sketchControlReducer;